export enum TrackingProductType {
  BORROW = 'borrow',
  MULTIPLY = 'multiply',
  EARN = 'earn',
  Automation = 'Automation',
  SwapWidget = 'SwapWidget',
  TopBanner = 'TopBanner',
}
